import React, { useEffect, useState, useRef } from 'react'
import IframeResizer from 'iframe-resizer-react'
import DOMPurify from 'dompurify'
import './index.css'

const Register = props => {
  const query = new URLSearchParams(window.location.search)
  const registration = query.get('RegToken')
  const registrationTokenSource = query.get('cid')
  const iframeRef = useRef(null)
  const registrationFormRef = useRef(null)
  const [isLoading, setIsLoading] = useState(true)

  const handleRegistrationBtnClick = e => {
    e.preventDefault()
    if (registrationFormRef.current) {
      registrationFormRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }

  useEffect(() => {
    const registrationAnchor = document.querySelector('a[href*="#registrationForm"]')
    if (registrationAnchor) {
      registrationAnchor.addEventListener('click', handleRegistrationBtnClick)
      return () => {
        registrationAnchor.removeEventListener('click', handleRegistrationBtnClick)
      }
    }
  }, [])

  const getIFrameDocument = () => {
    const iframe = document.getElementById('registration')
    const windowOrDocument = iframe.contentWindow || iframe.contentDocument
    return windowOrDocument.document ? windowOrDocument.document : windowOrDocument
  }

  const setIFrameStyles = () => {
    const iframeDocument = getIFrameDocument()
    const customStyle = iframeDocument.createElement('style')
    customStyle.setAttribute('type', 'text/css')
    const customCSS = [
      // if the form doesn't take up the whole iframe, we want the background colors to match
      'body { background-color: #f4f4f5!important }',

      // Hide the header, footer, and feedback button
      '#register-page div.registration-header, #register-page div div:nth-child(3) footer, #QSIFeedbackButton-btn { display: none !important; }',

      // Background color to match the registration section
      '#register-page .u-decoBackgroundLight { background: #f3f2f1 !important }',
      
      // Allow the card to fill the iframe box
      '#register-page section.u-sizeConstrained div.u-size7of12, #register-page section.u-sizeConstrained div.u-md-size8of10 { flex-basis: unset !important; width: 100% !important; }',

      // Don't center align
      '#register-page .Grid--alignCenter { -webkit-box-pack: start; justify-content: start; }',
      '#register-page section.u-sizeConstrained { margin: 0 !important; padding: 0 !important; }',
      '#w-reg-cancel { display: none; }',

      // Add margin for the card so we see the drop shadows
      '#register-page .Card { margin: 2px !important; }',

      // Remove misc padding & margin
      '#register-page div.u-paddingBottom10gu { padding-bottom: 0 !important; }',
      '#register-page .u-marginVert10gu { margin-top: 0 !important; margin-bottom: 0 !important; }',
    ]
    customStyle.innerHTML = customCSS.join(' ')
    iframeDocument.head.appendChild(customStyle)

    const iframeResizerContentWindow = iframeDocument.createElement('script')
    iframeResizerContentWindow.setAttribute('type', 'text/javascript')
    iframeResizerContentWindow.setAttribute('async', 'false')
    iframeResizerContentWindow.setAttribute(
      'src',
      DOMPurify.sanitize(`${window.AMPMSSITEPATH}iframe-resize.js`)
    )
    iframeDocument.body.appendChild(iframeResizerContentWindow)

    if (iframeRef && iframeRef.current) {
      iframeRef.current.resize()
    }

    setTimeout(fadeIn, 300)
  }

  const hideRegistrationFormElements = () => {
    setIsLoading(false)
    setTimeout(setIFrameStyles, 200)
  }

  const fadeIn = () => {
    const registrationElement = document.getElementById('registration')
    if (registrationElement) {
      registrationElement.style.display = 'block'
    }
  }

  const sanitizedSrc = DOMPurify.sanitize(
    registration && registrationTokenSource ? `/secure/register/?regToken=${registration}&cid=${registrationTokenSource}` : '/secure/register/')

  return (
    <>
      <section
        id='registrationForm'
        ref={registrationFormRef}
        className='RegistrationForm u-bgColorStone u-paddingVert8gu'
        aria-label='Registration form'>
        <div className='u-sizeConstrained'>
          <div className='Content u-lg-size8of12 u-lg-before2of12 u-lg-after2of12'>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.content.body) }} />
            {isLoading && (
                <div className="u-posRelative u-marginLeft5gu u-marginTop2gu">
                  <div className="Loading u-posAbsoluteCenter u-textColorBlack">
                    <div className="Loading-indicator"></div>
                    <div className="Loading-indicator"></div>
                    <div className="Loading-indicator"></div>
                  </div>
                </div>
             )}
            <div className='RegistrationForm--container u-bgColorStone'>
              <IframeResizer
                forwardRef={iframeRef}
                id='registration'
                title='Registration Form'
                heightCalculationMethod='max'
                style={{ width: '1px', minWidth: '100%', opacity: !isLoading ? 1 : 0, transition: 'opacity 0.3s ease-in'}}
                src={sanitizedSrc}
                scrolling='no'
                sizeHeight='true'
                maxWidth={window.innerWidth - 100}
                onMessage={() => {
                  console.log('onMessage loaded-', iframeRef, getIFrameDocument())
                }}
                onLoad={hideRegistrationFormElements}
              />
            </div>
            <div className='Content u-textRight u-paddingTop2gu u-paddingRight1gu'>
              <a href='/client-login' className='Link'>
                Already have access?
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Register
